module.exports = __webpack_public_path__ + "static/media/rw.2acf3355.svg";